// @flow
import * as React from 'react';
import gql from 'graphql-tag.macro';
import { Mutation } from '@apollo/react-components';

const LOGIN_OTP_REQUEST_MUTATION = gql`
  mutation otpRequest($phoneno: String!, $dialCode: String!) {
    otpRequest(phoneno: $phoneno, dialCode: $dialCode) {
      response
    }
  }
`;

export type RequestOTPInput = {
  phoneno: string,
  dialCode: string,
};

type Props = {
  children: ({
    isRequestingOTP: boolean,
    requestOTP: RequestOTPInput => Promise<any>,
  }) => React.Node,
};

const LoginOTPRequestContainer = ({ children }: Props) => (
  <Mutation mutation={LOGIN_OTP_REQUEST_MUTATION}>
    {(otpRequest, { loading, error, data }) =>
      children({
        isRequestingOTP: loading,
        requestOTP: variables => otpRequest({ variables }),
      })
    }
  </Mutation>
);

export default LoginOTPRequestContainer;
